<div class="flex !w-full">
  <input
    type="text"
    class="sub-header !w-[135px] !h-[44px] border text-center"
    [(ngModel)]="selectedColor"
    (input)="updateColorPicker()"
  />

  <div></div>
  <input
    type="color"
    class="!w-[35px] !h-[35px] rounded-full"
    id="color1"
    [(ngModel)]="selectedColor"
  />
</div>
